var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shownProperties && _vm.shownProperties.length
    ? _c("div", { staticClass: "small smallProp" }, [
        _c(
          "ul",
          { staticClass: "ml-0 pl-0" },
          _vm._l(_vm.shownProperties, function (property) {
            return _c("order-property-value-list-item", {
              key: property.propertyId,
              attrs: { property: property },
            })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }